import React from "react";
import styles from './viewBundle.module.sass'
import BundleInformation from './BundleInformation'
import { ToastContainer } from "react-toastify";

const ViewBundle = ({isChanged, setIsChanged}) => {
  return (
    <>
      <ToastContainer />
      <div className={styles.row}>
        <div className={styles.col}>
            <BundleInformation isChanged={isChanged} setIsChanged={setIsChanged} className={styles.card}/>
        </div>
      </div>
    </>
  )
}

export default ViewBundle